import EngagementModule from './engagement_module';

import template from '../templates/engagement_share_module.jst.ejs';

// App.Views.EngagementShareModule
export default EngagementModule.extend({
  template: template
});
